<div cdkDropList class="example-list mt-2" (cdkDropListDropped)="drop($event)">
    <!-- <div class="example-box" *ngFor="let movie of movies, index as i" cdkDrag> -->

    <!-- <div class="w-100 drag-content">
        <mat-checkbox (change)="movie.isDisable = !movie.isDisable">Click and drop only through icon</mat-checkbox>  
      </div>  -->

    <!-- </div> -->


    <div class="comparison-wrapper fw fh">
        <div class="header" *ngIf="!trends">
            <div class="example-action-buttons" *ngIf="!trends">
                <button mat-button (click)="toggleAll('E')"
                    [disabled]="!(comparedParamsList?.length && toggleStyle?.length)"> {{'common.expandAll' |
                    translate}}</button>
                <button mat-button (click)="toggleAll('C')"
                    [disabled]="!(comparedParamsList?.length && toggleStyle?.length)"> {{'common.collapsAll' |
                    translate}}</button>
            </div>
            <!-- <div class="togglesec" *ngIf="!trends">
            <button [disabled]="!(comparedParamsList?.length && !trends)" mat-raised-button *ngIf="!isCapability" class="time-series spc-btn"
                [color]="selectedTab==='time-series'?'primary':null" (click)="setSelectedGraphType('time-series')"
                type="submit">{{'common.time_series_small' |
                translate}}</button>
            <button [disabled]="!(comparedParamsList?.length && !trends)" mat-raised-button *ngIf="!isCapability" class="histogram spc-btn"
                [color]="selectedTab==='histogram'?'primary':null" (click)="setSelectedGraphType('histogram')"
                type="submit">{{'common.histogram_small' | translate}}</button>
            <button [disabled]="!(comparedParamsList?.length && !trends)" mat-raised-button *ngIf="isCapability" class="time-series spc-btn"
                [color]="selectedTab==='x'?'primary':null" (click)="setSelectedGraphType('x')" type="submit">X-bar</button>
            <button [disabled]="!(comparedParamsList?.length && !trends)" mat-raised-button *ngIf="isCapability" class="histogram spc-btn"
                [color]="selectedTab==='r'?'primary':null" (click)="setSelectedGraphType('r')" type="submit">R</button>
        </div> -->
            <div class="tile selection-tile button add-param" *ngIf="!trends">
                <div class="toggle-btn charts-toogle pr-2">
                    <mat-button-toggle-group [disabled]="!(comparedParamsList?.length && !trends)" name="chart-toggle"
                        [value]="selectedTab" (change)="onToggle($event)">
                        <mat-button-toggle [hidden]="isCapability" value="time-series" class="chart-font-header">
                            {{'common.time_series' |
                            translate}}</mat-button-toggle>
                        <mat-button-toggle [hidden]="isCapability" value="histogram" class="chart-font-header">
                            {{'common.histogram' | translate}}
                        </mat-button-toggle>
                        <mat-button-toggle [hidden]="!isCapability" value="x" class="chart-font-header">X Bar
                        </mat-button-toggle>
                        <mat-button-toggle [hidden]="!isCapability" value="r" class="chart-font-header">R
                        </mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
                <button class="mat-raised-button" (click)="selectNewParam(comparedParamsList?.length)">
                    {{'common.select_param_cap' | translate}}
                </button>
                <!-- <div class="button">
                    <div class="icon" (click)="selectNewParam(comparedParamsList?.length)"></div>
                    <span 
                        (click)="selectNewParam(comparedParamsList?.length)">{{'common.select_param_cap' |
                        translate}}</span>
                </div> -->
            </div>
        </div>


        <div class="tile-wrapper fw" *ngIf="!trends"
            [style.min-height]="comparedParamsList?.length? 'min-height: calc(100% - 60px)':'100%'">
            <div class="tile compared-parameter" *ngFor="let item of comparedParamsList, index as i" cdkDrag
                [ngClass]="!toggleStyle[i] ? 'hideColor':'showColor'">
                <div class="whitepatch"></div>
                <div class="close-btn" (click)="removeParam(i)"></div>
                <div class="param-dtls-header chart-filter-header moveCursor" cdkDragHandle>
                    <div class="top-split">
                        <div class="parameter-details">
                            <img *ngIf="toggleStyle[i]" alt="right Arraow" (click)="toggle(i)" width="17px"
                                class="trianleWidth" src="assets/images/triangle_right_arrow.svg">
                            <img *ngIf="!toggleStyle[i]" (click)="toggle(i)" alt="right lower Arraow" width="17px"
                                class="trianleWidth" src="assets/images/arrow_lowerright_icon.svg">

                            <!-- <span class="w-10 drag-icon">
                            <i *ngIf="false" class="material-icons disable">reorder</i>
                            <i  class="material-icons" cdkDragHandle>reorder</i>
                          </span> -->
                            <span *ngIf="toggleStyle[i]" class="ml-3 param-name" (mouseenter)="TagedPopOver(item)"
                                [popover]="popTemplate" triggers="mouseenter:mouseleave"
                                containerClass="customPopOverClass">
                                {{item?.parametername}}</span>

                            <div *ngIf="!toggleStyle[i]" class="criticality" [ngClass]="{
                    'aa':item?.classification === 'AA',   
                     'a':item?.classification === 'A',   
                    'b':item?.classification === 'B',   
                     'c':item?.classification === 'C' 
                          }">
                                <span>{{item?.classification}}</span>
                            </div>
                            <div class="main-dtls" *ngIf="!toggleStyle[i]">
                                <div class="param-name" (mouseenter)="TagedPopOver(item)" [popover]="popTemplate"
                                    triggers="mouseenter:mouseleave" containerClass="customPopOverClass">
                                    <span class="param-title">{{item?.parametername}}</span>
                                    <span class="edit" (click)="editComparedValues(item,i)">
                                        <span class="bracket">[</span>
                                        <span class="text" title="{{'common.edit' | translate}}"
                                            [ngClass]="{'text-len':comparedParamsList?.length>3}">
                                            {{'common.edit' | translate}}
                                        </span>
                                        <span class="bracket">]</span>
                                    </span>
                                </div>
                                <div class="specification" *ngIf="!toggleStyle[i]">
                                    {{item?.unit}}
                                </div>
                            </div>
                        </div>


                        <div class="button-grp chart-font-header" *ngIf="!toggleStyle[i]">
                            <div class="filter-wrapper fh font-common">
                                <div class="toggle-outlier mr-3">
                                    <div class="statistics-btn button-toggle">
                                        <div class="statistics-btn btn-align tile-toggle">
                                            <div class="custom-control custom-switch">
                                                <label class="switch ml-2">
                                                    <input type="checkbox" (click)="threeWayBtn1(item,$event,i)"
                                                        [id]="'with-Outlier_' + i"
                                                        [checked]="!($any(item)?.filter?.outliers) && !($any(item)?.filter?.obiousOutlier)">
                                                    <span class="slider round" id="'with-Outlier"
                                                        title="{{'common.without_obvious_outlier' | translate}}"></span>
                                                </label>

                                                <label class="switch ml-2">
                                                    <input type="checkbox" (click)="threeWayBtn1(item,$event,i)"
                                                        [id]="'with-ob-Outlier_' + i"
                                                        [checked]="!($any(item)?.filter?.outliers) && $any(item)?.filter?.obiousOutlier">
                                                    <span class="slider round" id="with-ob-Outlier"
                                                        title="{{'common.with_obvious_outlier' | translate}}"></span>
                                                </label>

                                                <label class="switch ml-2">
                                                    <input type="checkbox" (click)="threeWayBtn1(item,$event,i)"
                                                        [id]="'without-Outlier_' + i"
                                                        [checked]="$any(item)?.filter?.outliers">
                                                    <span class="slider round" id="without-Outlier"
                                                        title="{{'common.outlier' | translate}}"></span>
                                                </label>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="partition param-title mr-3"></div>
                            <div class="chart-options" *ngIf="item?.timeSeriesData?.length">
                                <div class="export" *ngIf="item?.timeSeriesData?.length" matRipple
                                    (click)="generateCSV(item)"></div>
                            </div> -->
                            </div>
                            <div class="export" (click)="generateCSV(item)" *ngIf="item?.timeSeriesData?.length"
                                matRipple>
                            </div>
                            <div class="fullscreen" *ngIf="item?.timeSeriesData?.length"></div>
                        </div>
                    </div>
                    <div class="bottom-split" *ngIf=false>
                        <div class="split" *ngIf="multiCluster && !trends">
                            <div class="label">
                                <span>{{'common.cluster' | translate}}</span>
                            </div>
                            <div class="value">
                                <span [matTooltip]="item?.cluster">{{item?.cluster}}</span>
                            </div>
                        </div>
                        <div class="split" *ngIf="multiCluster && !trends">
                            <div class="label">
                                <span>{{'common.factory' | translate}}</span>
                            </div>
                            <div class="value">
                                <span [matTooltip]="item?.factory">{{item?.factoryname}}</span>
                            </div>
                        </div>
                        <div class="split">
                            <div class="label">
                                <span>{{'common.line' | translate}}</span>
                            </div>
                            <div class="value">
                                <span [matTooltip]="item?.linename">{{item?.linename}}</span>
                            </div>
                        </div>
                        <div class="split">
                            <div class="label">
                                <span>{{'common.machine' | translate}}</span>
                            </div>
                            <div class="value">
                                <span [matTooltip]="item?.machinename">{{item?.machinename}}</span>
                            </div>
                        </div>
                        <div class="split">
                            <div class="label">
                                <span>{{'traceability.downloads.period' | translate}}</span>
                            </div>
                            <div class="value">
                                <span *ngIf="item?.assignedPeriodObj?.code !== 'comparison-custom'"
                                    [matTooltip]="item?.assignedPeriodObj?.name">{{item?.assignedPeriodObj?.name}}</span>
                                <span *ngIf="item?.assignedPeriodObj?.code === 'comparison-custom'"
                                    matTooltip="{{item?.assignedCustomPeriod?.from | date:'MMM d, y, HH:mm'}} to {{item?.assignedCustomPeriod?.to | date:'MMM d, y, HH:mm'}}">
                                    <span>{{item?.assignedCustomPeriod?.from | date:'MMM d, y, HH:mm'}}</span> &nbsp;
                                    <span>to</span>&nbsp;
                                    <span>{{item?.assignedCustomPeriod?.to | date:'MMM d, y, HH:mm'}}</span>
                                </span>
                            </div>
                        </div>
                        <div class="split">
                            <div class="label">
                                <span>{{'common.sku' | translate}}</span>
                            </div>
                            <div class="value">
                                <span [matTooltip]="item?.assignedSKUText">{{item?.assignedSKUText}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="!toggleStyle[i]" class="ml-3">
                    <div class="filter-cntnr chart-filter-header chart-font-header rules">
                        <div class="rules-outliers-wrapper fw">
                            <div class=""
                                *ngIf="(selectedTab==='time-series' || selectedTab==='r' || selectedTab==='x')">
                                <mat-checkbox class="unilever-spc-checkbox rule-cb usl-lsl"
                                    title="{{'common.lsl_usl' | translate}}" [(ngModel)]="$any(item).filter.usl_lsl">
                                    {{'common.lsl_usl' | translate}}
                                </mat-checkbox>
                            </div>
                            <div class="rules" *ngIf="!$any(item)?.filter?.outliers &&
                        (selectedTab==='time-series' || selectedTab==='r' || selectedTab==='x')">
                                <mat-checkbox class="unilever-spc-checkbox rule-cb rule1"
                                    title="{{'common.rule_1' | translate}}" [(ngModel)]="$any(item).filter.rule1">
                                    {{'common.rule_1' | translate}}
                                </mat-checkbox>
                                <mat-checkbox class="unilever-spc-checkbox rule-cb rule6"
                                    title="{{'common.rule_6' | translate}}" [(ngModel)]="$any(item).filter.rule6">
                                    {{'common.rule_6' | translate}}
                                </mat-checkbox>
                                <mat-checkbox class="unilever-spc-checkbox rule7"
                                    title="{{'common.rule_7' | translate}}" [(ngModel)]="$any(item).filter.rule7">
                                    {{'common.rule_7' | translate}}
                                </mat-checkbox>
                            </div>
                            <div class="kpi-dtls fw">
                                <div [ngClass]="parameterSelectorForm?.value?.period?.code === 'custom' ? 'custom' : 'live'"
                                    class="totalDataPoints marginTop">
                                    <span class="label" title="{{'common.points' | translate}}">
                                        {{'common.points' | translate}}:
                                    </span>
                                    <span
                                        *ngIf="$any(item)?.kpi?.totalDataPoints && !isCapability && !($any(item)?.filter?.outliers) && !($any(item)?.filter?.obiousOutlier)"
                                        class="calc-value">{{$any(item)?.kpi?.totalDataPoints}}</span>
                                    <span
                                        *ngIf="$any(item)?.kpi?.totalPoints && !isCapability && !($any(item)?.filter?.outliers) && $any(item)?.filter?.obiousOutlier"
                                        class="calc-value">{{$any(item)?.kpi?.totalPoints}}</span>
                                    <!-- <span
                                        *ngIf="item?.kpi?.totalPoints && !isCapability && !(item?.filter?.outliers) && item?.filter?.obiousOutlier"
                                        class="calc-value">{{item?.kpi?.totalPoints}}</span> -->
                                    <span
                                        *ngIf="item?.kpi?.totalDataPointsInlcudingManualOutlier && !isCapability && item?.filter?.outliers"
                                        class="calc-value">{{item?.kpi?.totalDataPointsInlcudingManualOutlier}}</span>
                                    <span *ngIf="item?.kpi?.totalPoints && isCapability"
                                        class="calc-value">{{item?.kpi?.totalPoints}}</span> &nbsp;
                                </div>

                                <div class="kpi sd marginTop">
                                    <span class="label">{{'common.sd' | translate}}:</span>
                                    <span *ngIf="(!item?.filter?.obiousOutlier && !item?.filter?.outliers)"
                                        class="sdv value">{{item?.kpi?.sigmaval?.toFixed(2)}}</span>
                                    <span class="value sdv"
                                        *ngIf="item?.filter?.obiousOutlier">{{item?.kpi?.withOutliersSigmaval?.toFixed(2)}}</span>
                                    <span *ngIf="(item?.filter?.outliers)"
                                        class="sdv value">{{item?.kpi?.includingManualOutliersSigmaval?.toFixed(2)}}</span>
                                </div>
                                <div class="kpi cp marginTop">
                                    <span *ngIf="isCapability" class="label">{{'common.cp' | translate}}:</span>
                                    <span *ngIf="!isCapability" class="label">{{'common.pp' | translate}}:</span>

                                    <span class="value ccp"
                                        *ngIf="(!$any(item)?.filter?.obiousOutlier && !item?.filter?.outliers)">
                                        <span class="ccp-infinity" *ngIf="($any(item)?.kpi?.sigmaval === 0 || $any(item)?.kpi?.xcp === null)&&
                                    item?.timeSeriesData">
                                            <img class="infinite-symbol" alt="infinite"
                                                src="assets/images/infinity.svg">
                                        </span>
                                        <span class="ccp-value"
                                            *ngIf="$any(item)?.kpi?.sigmaval !== 0  && !($any(item)?.kpi?.xcp === null)">
                                            {{$any(item)?.kpi?.xcp?.toFixed(2)}}
                                        </span>
                                    </span>
                                    <span class="ccp value" *ngIf="$any(item)?.filter?.obiousOutlier">
                                        <span class="comcp-infinity" *ngIf="($any(item)?.kpi?.withOutliersSigmaval === 0 || $any(item)?.kpi?.xcpWithOutLiers === null)&&
                                    item?.timeSeriesData">
                                            <img class="infinite-symbol" alt="infinite"
                                                src="assets/images/infinity.svg">
                                        </span>
                                        <span class="comcp-value"
                                            *ngIf="item?.kpi?.withOutliersSigmaval !== 0 && !(item?.kpi?.xcpWithOutLiers === null)">
                                            {{item?.kpi?.xcpWithOutLiers?.toFixed(2)}}
                                        </span>
                                    </span>
                                </div>
                                <div class="kpi cpk marginTop">
                                    <span *ngIf="isCapability" class="label">{{'common.cpk' | translate}}:</span>
                                    <span *ngIf="!isCapability" class="label">{{'common.ppk' | translate}}:</span>

                                    <span *ngIf="(!$any(item)?.filter?.obiousOutlier && !item?.filter?.outliers)"
                                        class="ccpk value">
                                        <span class="ccpk-infinity" *ngIf="($any(item)?.kpi?.sigmaval === 0 || $any(item)?.kpi?.xcpk=== null)&&
                                    item?.timeSeriesData">
                                            <img class="infinite-symbol" alt="infinite"
                                                src="assets/images/infinity.svg">
                                        </span>
                                        <span class="ccpk-value"
                                            *ngIf="$any(item)?.kpi?.sigmaval !== 0 && !($any(item)?.kpi?.xcpk=== null)">
                                            {{$any(item)?.kpi?.xcpk?.toFixed(2)}}
                                        </span>
                                    </span>
                                    <span class="value ccpk" *ngIf="$any(item)?.filter?.obiousOutlier">
                                        <span class="comcpk-infinity" *ngIf="($any(item)?.kpi?.withOutliersSigmaval === 0 || $any(item)?.kpi?.xcpkWithOutLiers=== null)&&
                                    item?.timeSeriesData">
                                            <img class="infinite-symbol" alt="infinite"
                                                src="assets/images/infinity.svg">
                                        </span>
                                        <span class="comcpk-value"
                                            *ngIf="item?.kpi?.withOutliersSigmaval !== 0 && !(item?.kpi?.xcpkWithOutLiers=== null)">
                                            {{item?.kpi?.xcpkWithOutLiers?.toFixed(2)}}
                                        </span>
                                    </span>
                                </div>

                                <div class="kpi avg marginTop">
                                    <span class="label">{{'common.avg' | translate}}:</span>

                                    <span *ngIf="(!$any(item)?.filter?.obiousOutlier && !item?.filter?.outliers)"
                                        class="value">{{$any(item)?.kpi?.avg?.toFixed(2)}}</span>
                                    <span class="value"
                                        *ngIf="$any(item)?.filter?.obiousOutlier">{{$any(item)?.kpi?.withOutliersAvg?.toFixed(2)}}</span>
                                    <span *ngIf="(item?.filter?.outliers)"
                                        class="value">{{item?.kpi?.includingManualOutliersAvg?.toFixed(2)}}</span>
                                </div>
                            </div>

                            <div class="slide-toggle outliers">
                                <!-- <div [hidden]="!$any(item)?.filter?.outliers">
                            <mat-checkbox class="unilever-spc-checkbox rule-cb usl-lsl"
                                [(ngModel)]="$any(item).filter.usl_lsl">
                                {{'common.lsl_usl' | translate}}11
                            </mat-checkbox>
                        </div> -->
                                <!-- <div class="separator" [hidden]="!$any(item)?.filter?.outliers"></div>
                        <div class="comparison-btn button-toggle">
                            <div class="comparison-btn btn-align">
                                <mat-button-toggle-group (change)="threeWayBtn(item,$event)">
                                    <mat-button-toggle
                                        [checked]="!($any(item)?.filter?.outliers) && !($any(item)?.filter?.obiousOutlier)"
                                        value="with-Outlier"></mat-button-toggle>
                                    <mat-button-toggle
                                        [checked]="!($any(item)?.filter?.outliers) && $any(item)?.filter?.obiousOutlier"
                                        value="with-ob-Outlier"></mat-button-toggle>
                                    <mat-button-toggle value="without-Outlier" [checked]="$any(item)?.filter?.outliers">
                                    </mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>
                            <div class="comparison-btn button-desc">
                                <span class="outlier"
                                    *ngIf="!($any(item)?.filter?.outliers) && !($any(item)?.filter?.obiousOutlier)">
                                    {{'common.without_obvious_outlier' | translate}}</span>
                                <span class="without-outlier" *ngIf="$any(item)?.filter?.outliers">
                                    {{'common.outlier' | translate}}</span>
                                <span class="ob-outlier"
                                    *ngIf="!($any(item)?.filter?.outliers) && $any(item)?.filter?.obiousOutlier">
                                    {{'common.with_obvious_outlier' | translate}}</span>
                            </div>
                        </div> -->
                                <div class="flag outlierfont"
                                    *ngIf="item.datasource!=='SQL' && selectedTab!=='histogram'"
                                    [ngClass]="{'text-overfflow':comparedParamsList?.length>3}">
                                    <ng-template
                                        [ngxPermissionsOnly]="['Statistics Continuous Update', 'Statistics Batch Update']"
                                        *ngIf="!isCapability">
                                        <span
                                            *ngIf="MarkAsOutlierOnHistoricalData && MarkAsOutlierOnwithobviousoutlier && parameterSelectorForm?.value?.period?.code !== '50points'"
                                            [ngClass]="[selectedParam?.id === item?.id && selectedPoints?.length !== 0 ?'manual-outlier-btn':'disable-pop', parameterSelectorForm?.value?.period?.value !== 'comparison-custom' ? 'manual-outlier-btn':'remove-button']"
                                            (click)="openMarkAsOutlierPopup(item,i)"
                                            [hidden]="!(item?.timeSeriesData?.length && !$any(item)?.filter?.outliers) || item?.allOutliers"
                                            [outsideClick]="true" containerClass="outlier-info-popover"
                                            title="{{'common.mark_as_outlier' | translate}}">
                                            {{'common.mark_as_outlier' | translate}}
                                        </span>
                                        <span class="manual-outlier-btn" title="{{'common.remove_outlier' | translate}}"
                                            (click)="removeManualOutliers(item,i)"
                                            [hidden]="!(item?.timeSeriesData?.length && $any(item)?.filter?.outliers) || !item?.manualOutlierPresent">
                                            {{'common.remove_outlier' | translate}}</span>
                                    </ng-template>
                                </div>
                            </div>
                        </div>


                    </div>

                    <div class="graph-block fw">
                        <div class="graph time-series fw fh"
                            *ngIf="(selectedTab==='time-series' || selectedTab==='r' || selectedTab==='x')">


                            <ng-template #markAsOutlier>
                                <app-outliers-info-capture [selectedPoints]="selectedPoints"
                                    [selectedParam]="selectedParam"
                                    (afterSubmit)="afterOutlierSubmit($event,selectedParam)">
                                </app-outliers-info-capture>
                            </ng-template>

                            <app-c3-time-series *ngIf="item?.batch!=='1' && !isCapability" [data]="item?.timeSeriesData | ruleOutlierFilter : $any(item)?.filter?.usl_lsl: $any(item)?.filter?.rule1: $any(item)?.filter?.rule6 : $any(item)?.filter?.rule7 : $any(item)?.filter?.outliers : $any(item)?.filter?.obiousOutlier :
                        item?.yzoom?.zoom : item?.isHistogram" [kpi]="item?.kpi" [paramName]="item?.parametername"
                                [rule1Enabled]="$any(item)?.filter?.rule1" [rule6Enabled]="$any(item)?.filter?.rule6"
                                [rule7Enabled]="$any(item)?.filter?.rule7" [outliers]="$any(item)?.filter?.outliers"
                                [uslLsl]="$any(item)?.filter?.usl_lsl" [redZone]="$any(item)?.filter?.redZone"
                                [yzoom]="{max:null,min:null}" [inclindXaxis]="0"
                                (pointSelection)="selectedPointsChange($event,item)">
                            </app-c3-time-series>

                            <app-c3-batch-series *ngIf="item?.batch==='1' || isCapability" [data]="item?.timeSeriesData | ruleOutlierFilter : $any(item)?.filter?.usl_lsl: $any(item)?.filter?.rule1: $any(item)?.filter?.rule6 : $any(item)?.filter?.rule7 : $any(item)?.filter?.outliers : $any(item)?.filter?.obiousOutlier :
                        item?.yzoom?.zoom : item?.isHistogram" [kpi]="item?.kpi" [paramName]="item?.parametername"
                                [rule1Enabled]="$any(item)?.filter?.rule1" [rule6Enabled]="$any(item)?.filter?.rule6"
                                [rule7Enabled]="$any(item)?.filter?.rule7" [outliers]="$any(item)?.filter?.outliers"
                                [uslLsl]="$any(item)?.filter?.usl_lsl" [redZone]="$any(item)?.filter?.redZone"
                                [yzoom]="{max:null,min:null}" [inclindXaxis]="0" [isCapability]="isCapability"
                                (pointSelection)="selectedPointsChange($event,item)">
                            </app-c3-batch-series>
                        </div>

                        <div class="graph histogram fw fh" *ngIf="selectedTab==='histogram' && !isCapability">
                            <app-histogram [data]="item?.timeSeriesData | ruleOutlierFilter : $any(item)?.filter?.usl_lsl: $any(item)?.filter?.rule1: $any(item)?.filter?.rule6 : $any(item)?.filter?.rule7 : $any(item)?.filter?.outliers : $any(item)?.filter?.obiousOutlier :
                        item?.yzoom?.zoom : item?.isHistogram" [kpi]="item?.kpi"
                                [outliers]="$any(item)?.filter?.outliers" [uslLsl]="$any(item)?.filter?.usl_lsl">
                            </app-histogram>
                        </div>


                    </div>
                    <div *ngIf="item?.assignedPeriodObj?.code === 'comparison-custom' && item?.timeSeriesData?.length"
                        class="headerButtons">
                        <app-chart-paginator *ngIf="item.totalPoints > 0" [totalPoints]="item.totalPoints"
                            (pagChange)="chartChange(item, $event)">
                        </app-chart-paginator>
                    </div>
                </div>
            </div>


            <!-- <div class="tile selection-tile disabled" *ngIf="comparedParamsList?.length===0">
            <div class="button">
                <div class="icon"></div>
                <span *ngIf="comparedParamsList?.length < 2">{{'common.select_param_cap' | translate}}</span>
            </div>
        </div> -->
        </div>
        <div class="tile-wrapper fh fw" *ngIf="trends">
            <div class="trend-container">
                <div class="module-title title-cntr" *ngIf="false">
                    <span>{{'menuList.trends' | translate}}</span>
                </div>
                <div class="trend-button fh"
                    *ngIf="comparedParamsList?.length===0 || comparedParamsList[0].parameterDtls.length === 0">
                    <div class="icon" (click)="selectNewParam(comparedParamsList?.length);operationType='add'"></div>
                    <span class="tred-select-label"
                        (click)="selectNewParam(comparedParamsList?.length);operationType='add'">{{'common.select_param_cap'
                        | translate}}</span>
                </div>
                <div *ngIf="comparedParamsList?.length">
                    <div>
                        <div class="trend-param-name chart-filter-header" [ngClass]="{
                        'treands-param-name-selfalign':maxTrends === 6   
                        }">
                            <div class="trend-criticality"
                                *ngFor="let item of comparedParamsList[0].parameterDtls; let i= index;">
                                <div class="criticality criticality-size" [ngClass]="{
                    'aa':item?.classification === 'AA',   
                     'a':item?.classification === 'A',   
                    'b':item?.classification === 'B',   
                     'c':item?.classification === 'C' 
                          }">
                                    <span>{{item?.classification}}</span>
                                </div>
                                <div class="trend-param-elipses">
                                    <span class="param-name"
                                        [matTooltip]="item?.parametername">{{item?.parametername}}</span>
                                </div>
                                <div class="edit-img"><img src="assets/images/edit.svg"
                                        (click)="editComparedValues(comparedParamsList[0],i);operationType='edit'"
                                        alt="edit"></div>
                                <div class="trend-close-btn" (click)="removeTrendParam(item,i)"></div>
                                <span class="edit" *ngIf="i===comparedParamsList[0].parameterDtls.length-1"
                                    (click)="editComparedValues(comparedParamsList[0],0);operationType='edit'">
                                </span>
                            </div>
                            <div *ngIf="trendParamsNameList.length<maxTrends" class="trend-icon"
                                (click)="selectNewParam(-1);operationType='add'" matTooltip="Add Parameter"></div>
                        </div>
                    </div>
                </div>
                <div class="trend-graph-area fw"
                    *ngIf="comparedParamsList?.length && comparedParamsList[0].parameterDtls.length">
                    <div class="pagination-wrapper"
                        *ngIf="comparedParamsList[0]?.parameterDtls[0]?.assignedPeriodObj?.code === 'comparison-custom'">
                        <div class="left-btn"><button mat-raised-button
                                [ngClass]="{'pagination-disable':chartfirstIndex===0}"
                                class="pagination-button pagination-button-left" color="primary"
                                (click)="paginationChange(chartfirstIndex,'back')"><img src="assets/images/icn-left.svg"
                                    class="image-fit" alt="Previous-btn"></button>
                        </div>
                    </div>
                    <div
                        [ngClass]="{'trend-chart': comparedParamsList[0]?.parameterDtls[0]?.assignedPeriodObj?.code === 'comparison-custom'}">
                        <app-c3-trend-series [data]="trendParamsList" [param1]="trendParamsList[0]?.timeSeriesDatas"
                            [param2]="trendParamsList[1]?.timeSeriesDatas"
                            [param3]="trendParamsList[2]?.timeSeriesDatas"
                            [param4]="trendParamsList[3]?.timeSeriesDatas"
                            [param5]="trendParamsList[4]?.timeSeriesDatas"
                            [param6]="trendParamsList[5]?.timeSeriesDatas" [paramNameList]="trendParamsNameList">
                        </app-c3-trend-series>
                    </div>
                    <div class="pagination-wrapper"
                        *ngIf="comparedParamsList[0]?.parameterDtls[0]?.assignedPeriodObj?.code === 'comparison-custom'">
                        <div class="right-btn">
                            <button mat-raised-button [ngClass]="{'pagination-disable': !moreRecords}"
                                class="pagination-button pagination-button-right" color="primary"
                                (click)="paginationChange(chartfirstIndex,'next')"><img
                                    src="assets/images/icn-right.svg" class="image-fit" alt="Next-btn"></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!---------------------------------------------------------------Test-----Select Parameter-->
<ng-template #paramSelector>
    <mat-dialog-actions class="dialog-close">
        <img src="assets/images/dialog-close.svg" class="close-btn" alt="close" matRipple mat-dialog-close>
    </mat-dialog-actions>
    <div class="dialog-content machine-details-capture">
        <div class="dialog-title">
            <span>{{'common.select_param' | translate}}</span>
        </div>
        <div class="dialog-sub-title" *ngIf="!multiCluster">
            <div class="sub-title-set location ellipses">
                <img src="assets/images/location.svg" alt="Location" class="icon" />
                <span class="location" title="{{selectedGranularity?.cluster?.name}}">
                    {{selectedGranularity?.cluster?.name}}
                </span>
            </div>
            <div class="sub-title-set factory ellipses">
                <img src="assets/images/factory.svg" alt="Factory" class="icon" />
                <span class="factory" title="{{selectedGranularity?.factory?.name}}">
                    {{selectedGranularity?.factory?.name}}
                </span>
            </div>
        </div>
        <div class="dialog-form">
            <form (ngSubmit)="submitDtls()" [formGroup]="parameterSelectorForm">
                <div class="dialog-sub-title-ga" *ngIf="multiCluster">
                    <div class="sub-title-set location ellipses">
                        <mat-form-field appearance="outline" class="fw" style="margin-top: 5px;">
                            <mat-label appRemoveAriaOwns>{{'common.select_cluster' | translate}}</mat-label>
                            <mat-select #selectcluster formControlName="cluster" (selectionChange)="getFactories()"
                                required>
                                <mat-option class="search-option" (keydown)="$event.stopPropagation()">
                                    <lib-mat-select-search [list]="clusterList" [searchProperties]="['name']"
                                        (filtered)="clusterListFilter = $event">
                                    </lib-mat-select-search></mat-option>
                                <mat-option *ngFor="let cluster of clusterListFilter" [value]="cluster">
                                    {{cluster.name}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="sub-title-set factory ellipses">
                        <mat-form-field appearance="outline" class="fw" style="margin-top: 5px;">
                            <mat-label appRemoveAriaOwns>{{'common.select_factory' | translate}}</mat-label>
                            <mat-select #selectfactory formControlName="factory"
                                (selectionChange)="getFactoryOffset($event)" required>
                                <mat-option class="search-option" (keydown)="$event.stopPropagation()">
                                    <lib-mat-select-search [list]="factoryList" [searchProperties]="['name']"
                                        (filtered)="factoryListFilter = $event">
                                    </lib-mat-select-search> </mat-option><mat-option
                                    *ngFor="let factory of factoryListFilter" [value]="factory">
                                    {{factory.name}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="drop-down-cntnr">
                    <mat-form-field appearance="outline" class="fw spc-form-field">
                        <mat-label appRemoveAriaOwns>{{'common.select_line' | translate}}</mat-label>
                        <mat-select #selectLine formControlName="line" (selectionChange)="lineChanged()" required>
                            <mat-option class="search-option" (keydown)="$event.stopPropagation()">
                                <lib-mat-select-search [list]="lineList" [searchProperties]="['linename']"
                                    (filtered)="lineListFilter = $event">
                                </lib-mat-select-search>
                            </mat-option>
                            <mat-option *ngFor="let line of lineListFilter" [value]="line">
                                {{line.linename}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="drop-down-cntnr">
                    <mat-form-field appearance="outline" class="fw spc-form-field">
                        <mat-label appRemoveAriaOwns>{{'common.machine' | translate}}</mat-label>
                        <mat-select #selectmachine formControlName="machine"
                            (selectionChange)="getParamsUnderMachine();machineChanged();" required>
                            <mat-option class="search-option" (keydown)="$event.stopPropagation()">
                                <lib-mat-select-search [list]="machineList" [searchProperties]="['machinename']"
                                    (filtered)="machineListFilter = $event">
                                </lib-mat-select-search> </mat-option><mat-option
                                *ngFor="let machine of machineListFilter" [value]="machine">
                                {{machine?.machinename}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="drop-down-cntnr" *ngIf="isCapability">
                    <mat-form-field appearance="outline" class="fw spc-form-field">
                        <mat-label appRemoveAriaOwns>Sub Group Sampling</mat-label>
                        <mat-select formControlName="sampling" required>
                            <mat-option *ngFor="let sampling of samplingGroup" [value]="sampling">
                                {{sampling}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="param-type radio-grp radio-button">
                    <label class="radio-label ">{{'spc.configurator.parameter.type' | translate}}</label>
                    <mat-radio-group aria-label="classification-radio-group-label" class="classification-radio-group"
                        (change)="paramTypeChanged()" formControlName="paramType">
                        <mat-radio-button value="all" *ngIf="!trends && !isCapability" class="sigle-bulk-radio-button">
                            {{'common.all' | translate}}
                        </mat-radio-button>
                        <mat-radio-button value="continous" class="sigle-bulk-radio-button">
                            {{'common.continuos' | translate}}
                        </mat-radio-button>
                        <mat-radio-button value="batch" *ngIf="!trends" class="sigle-bulk-radio-button">
                            {{'common.batch' | translate}}
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
                <div class="drop-down-cntnr">
                    <mat-form-field appearance="outline" class="fw spc-form-field">
                        <mat-label appRemoveAriaOwns>{{'common.period_local' | translate}}</mat-label>
                        <mat-select formControlName="period" (selectionChange)="periodChanged($event)" required>
                            <mat-option *ngFor="let period of periodList" (click)="periodClick()" [value]="period">
                                {{period?.name}}</mat-option>
                        </mat-select>
                        <mat-hint *ngIf="parameterSelectorForm?.value?.period?.code === 'comparison-custom' && !trends"
                            align="end">
                            {{'common.selected_period' | translate}}:
                            {{customPeriodHint.from | date:'MMM d, y, HH:mm'}} -
                            {{customPeriodHint.to | date:'MMM d, y, HH:mm'}}
                        </mat-hint>
                        <mat-hint *ngIf="parameterSelectorForm?.value?.period?.code === 'comparison-custom' && trends"
                            align="end">
                            {{'common.selected_period' | translate}}:
                            {{selCustDate.convertedFrom | date:'MMM d, y, HH:mm'}} -
                            {{selCustDate.convertedTo | date:'MMM d, y, HH:mm'}}
                        </mat-hint>
                    </mat-form-field>
                </div>
                <div class="drop-down-cntnr" style="margin-bottom: 18px;">
                    <mat-form-field appearance="outline" class="fw spc-form-field" style="height: 48px;"
                        [class.inactive-option]="isactiveSku === false">
                        <mat-label appRemoveAriaOwns>{{'common.sku' | translate}}</mat-label>
                        <input type="text" placeholder="SKU" matInput required formControlName="sku"
                            (change)="setAutoCompleteStatus('sku',false)" [matAutocomplete]="autoSku">
                        <mat-autocomplete #autoSku="matAutocomplete" [displayWith]="utilSer.mapSKUName">
                            <mat-option *ngFor="let sku of filteredList.sku | async" [value]="sku"
                                [matTooltip]="sku.skuName" matTooltipPosition="right"
                                (click)="setAutoCompleteStatus('sku',true)"
                                [class.inactive-optionlist]="sku?.IsActive === false">
                                {{sku?.skuName}}</mat-option>
                        </mat-autocomplete>
                        <mat-hint class="error" align="end" *ngIf="!autoCompleteStatus?.sku &&
                        parameterSelectorForm?.controls?.sku.touched &&
                        parameterSelectorForm?.controls?.sku.dirty">
                            {{'common.sku_alert' | translate}} <strong>{{'common.list' | translate}}</strong>!
                        </mat-hint>
                        <mat-hint *ngIf="parameterSelectorForm.controls['sku'].hasError('noSkuFound')"
                            class="error sku-mat-error2">
                            <strong> {{'spc.dashboard.sku_alert2' | translate}}</strong>
                        </mat-hint>
                    </mat-form-field>
                </div>

                <div class="drop-down-cntnr" *ngIf="!trends">
                    <mat-form-field appearance="outline" class="fw spc-form-field">
                        <mat-label>{{'common.parameter' | translate}}</mat-label>
                        <input type="text" placeholder="Parameter" matInput formControlName="parameter"
                            (change)="setAutoCompleteStatus('parameter',false)" [matAutocomplete]="autoParam">
                        <mat-autocomplete #autoParam="matAutocomplete" [displayWith]="mapParamName">
                            <mat-option *ngFor="let param of filteredList.parameters | async" [value]="param"
                                (click)="setAutoCompleteStatus('parameter',true)">
                                {{param?.parametername}}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-hint class="error" align="end" *ngIf="!autoCompleteStatus?.parameter &&
                            parameterSelectorForm?.controls?.parameter.touched &&
                            parameterSelectorForm?.controls?.parameter.dirty">
                            {{'common.param_alert' | translate}} <strong>{{'common.list' | translate}}</strong>!
                        </mat-hint>
                    </mat-form-field>
                </div>
                <div *ngIf="trends">
                    <mat-form-field appearance="outline" class="fw spc-form-field">
                        <mat-label appRemoveAriaOwns>{{'common.parameter' | translate}}</mat-label>
                        <mat-select #selectParam formControlName="parametersFilter" multiple>
                            <mat-option class="search-option" (keydown)="$event.stopPropagation()">
                                <lib-mat-select-search [list]="parametersList" [searchProperties]="['parametername']"
                                    (filtered)="parametersListFilter = $event">
                                </lib-mat-select-search></mat-option> <mat-option
                                *ngFor="let param of parametersListFilter" [value]="param">
                                {{param?.parametername}}
                            </mat-option>
                        </mat-select>

                        <mat-hint class="error" align="end" *ngIf="parameterSelectorForm?.controls?.parametersFilter.value.length+
                            trendParamsNameList.length>(operationType==='add'?maxTrends:maxTrends+1)">
                            {{'common.trends_alert' | translate}} <strong>{{maxTrends}}
                            </strong> {{'common.parameter_small' | translate}}!
                        </mat-hint>
                    </mat-form-field>
                </div>
                <div class="btn-cntnr">
                    <button mat-raised-button class="add-btn spc-btn" color="primary" type="submit" [disabled]="!parameterSelectorForm.valid || !autoCompleteStatus?.parameter || !autoCompleteStatus?.sku ||
                        parameterSelectorForm?.controls?.parametersFilter.value.length+
                        trendParamsNameList.length>(operationType==='add'?maxTrends:maxTrends+1)">
                        {{'common.select' | translate}}</button>
                </div>
            </form>
        </div>
    </div>
</ng-template>

<ng-template #customDateSelector>
    <app-custom-date-selector (applyDate)=applyCustomToSelectedDate($event)
        [period]="parameterSelectorForm.value?.period">
    </app-custom-date-selector>
</ng-template>

<ng-template #popTemplate>

    <table summary="show clustor & factory">
        <tr>
            <th class="chart-font-header" id="cluster">
                Cluster:
            </th>
            <td>
                &nbsp;{{popoverData.cluster}}
            </td>
            <th class="chart-font-header" id="factory">
                &nbsp;Factory:
            </th>
            <td>
                &nbsp;{{popoverData.fname}}
            </td>
        </tr>
        <tr>
            <th class="chart-font-header" id="line">
                Line:
            </th>
            <td>
                &nbsp;{{popoverData.linename}}
            </td>
            <th class="chart-font-header" id="sku">
                &nbsp;Sku:
            </th>
            <td>
                &nbsp;{{popoverData.assignedSKUText}}
            </td>
        </tr>
    </table>
</ng-template>